import React, { useState } from "react";
import { Modal } from "antd";
import { Document, Page, pdfjs } from "react-pdf";

interface PDFPreviewProps {
  pdfUrl: string;
}

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const PDFPreview: React.FC<PDFPreviewProps> = ({ pdfUrl }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [numPages, setNumPages] = useState<number>(0);
  const [pageNumber] = useState(1);
  const [isPdf, setIsPdf] = useState(true);
  const showModal = () => {
    setIsOpen(true);
  };

  const handleCancel = () => {
    setIsOpen(false);
  };

  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setNumPages(numPages);
    setIsPdf(true);
  };

  const onDocumentLoadError = () => {
    setIsPdf(false);
  };

  return (
    <>
      <div onClick={showModal} style={{ cursor: "pointer" }}>
        {isPdf ? (
          <Document
            file={pdfUrl}
            onLoadSuccess={onDocumentLoadSuccess}
            onLoadError={onDocumentLoadError}
          >
            <Page pageNumber={pageNumber} />
          </Document>
        ) : (
          <img src={pdfUrl} alt="Preview" style={{ maxWidth: "100%" }} />
        )}
      </div>

      <Modal
        open={isOpen}
        title={isPdf ? "PDF Preview" : "Image Preview"}
        onCancel={handleCancel}
        footer={null}
        width={800} // Adjust the width as needed
      >
        {isPdf ? (
          <Document file={pdfUrl} onLoadSuccess={onDocumentLoadSuccess}>
            <Page pageNumber={pageNumber} />
          </Document>
        ) : (
          <img src={pdfUrl} alt="Preview" style={{ maxWidth: "100%" }} />
        )}
      </Modal>
    </>
  );
};

export default PDFPreview;
